// Static data for Wedding Planner module
// Will be replaced with API data when backend is ready

export const taskCategories = [
  { id: 1, name: "To'yxona",        icon: 'HomeOutlined',            color: '#5F33E1', sortOrder: 1 },
  { id: 2, name: "Honanda",         icon: 'CustomerServiceOutlined', color: '#E91E63', sortOrder: 2 },
  { id: 3, name: "Fotograf/Video",  icon: 'CameraOutlined',          color: '#FF9800', sortOrder: 3 },
  { id: 4, name: "Ko'ylak/Kostyum", icon: 'SkinOutlined',            color: '#00BCD4', sortOrder: 4 },
  { id: 5, name: "Gullar",          icon: 'GiftOutlined',            color: '#4CAF50', sortOrder: 5 },
  { id: 6, name: "Transport",       icon: 'CarOutlined',             color: '#795548', sortOrder: 6 },
  { id: 7, name: "Oshpaz/Taom",     icon: 'CoffeeOutlined',          color: '#FF5722', sortOrder: 7 },
  { id: 8, name: "Bezak/Dekor",     icon: 'StarOutlined',            color: '#9C27B0', sortOrder: 8 },
  { id: 9, name: "Muzika (DJ)",     icon: 'SoundOutlined',           color: '#3F51B5', sortOrder: 9 },
  { id: 10, name: "Boshqa",         icon: 'AppstoreOutlined',        color: '#607D8B', sortOrder: 10 },
];

export const defaultTasks = [
  // To'yxona
  { id: 1,  categoryId: 1,  title: "To'yxona tanlash va band qilish",        estimatedCost: 15000000, sortOrder: 1 },
  { id: 2,  categoryId: 1,  title: "Zal bezatish bo'yicha kelishish",        estimatedCost: 3000000,  sortOrder: 2 },
  { id: 3,  categoryId: 1,  title: "Mehmonlar uchun joy tartibini belgilash", estimatedCost: 0,        sortOrder: 3 },

  // Honanda
  { id: 4,  categoryId: 2,  title: "Honanda tanlash va shartnoma tuzish",    estimatedCost: 5000000,  sortOrder: 1 },
  { id: 5,  categoryId: 2,  title: "Qo'shiqlar ro'yxatini tuzish",          estimatedCost: 0,        sortOrder: 2 },

  // Fotograf/Video
  { id: 6,  categoryId: 3,  title: "Fotograf band qilish",                  estimatedCost: 3000000,  sortOrder: 1 },
  { id: 7,  categoryId: 3,  title: "Videograf band qilish",                 estimatedCost: 4000000,  sortOrder: 2 },
  { id: 8,  categoryId: 3,  title: "Pre-wedding fotosessiya",               estimatedCost: 1500000,  sortOrder: 3 },

  // Ko'ylak/Kostyum
  { id: 9,  categoryId: 4,  title: "Kelin ko'ylagi tanlash/tikish",         estimatedCost: 5000000,  sortOrder: 1 },
  { id: 10, categoryId: 4,  title: "Kuyov kostyumi tayyorlash",             estimatedCost: 3000000,  sortOrder: 2 },
  { id: 11, categoryId: 4,  title: "Kelin aksessuarlari (toj, tufli...)",   estimatedCost: 2000000,  sortOrder: 3 },

  // Gullar
  { id: 12, categoryId: 5,  title: "Kelin guldastasi buyurtma berish",      estimatedCost: 500000,   sortOrder: 1 },
  { id: 13, categoryId: 5,  title: "Zal uchun gul bezak",                   estimatedCost: 2000000,  sortOrder: 2 },

  // Transport
  { id: 14, categoryId: 6,  title: "Kelin mashinasi ijarasi",               estimatedCost: 2000000,  sortOrder: 1 },
  { id: 15, categoryId: 6,  title: "Mehmonlar uchun transport",             estimatedCost: 1500000,  sortOrder: 2 },

  // Oshpaz/Taom
  { id: 16, categoryId: 7,  title: "Menyu tanlash va kelishish",            estimatedCost: 0,        sortOrder: 1 },
  { id: 17, categoryId: 7,  title: "Tort buyurtma berish",                  estimatedCost: 1500000,  sortOrder: 2 },
  { id: 18, categoryId: 7,  title: "Ichimliklar tayyorlash",                estimatedCost: 1000000,  sortOrder: 3 },

  // Bezak/Dekor
  { id: 19, categoryId: 8,  title: "Fotozona tayyorlash",                   estimatedCost: 1500000,  sortOrder: 1 },
  { id: 20, categoryId: 8,  title: "Dasturxon bezagi (guldon, sham...)",    estimatedCost: 1000000,  sortOrder: 2 },

  // Muzika (DJ)
  { id: 21, categoryId: 9,  title: "DJ/Tamada band qilish",                estimatedCost: 3000000,  sortOrder: 1 },
  { id: 22, categoryId: 9,  title: "Musiqa asboblari ijarasi",             estimatedCost: 2000000,  sortOrder: 2 },

  // Boshqa
  { id: 23, categoryId: 10, title: "Taklifnomalar chop etish",             estimatedCost: 500000,   sortOrder: 1 },
  { id: 24, categoryId: 10, title: "Sovg'alar tayyorlash",                 estimatedCost: 1000000,  sortOrder: 2 },
  { id: 25, categoryId: 10, title: "Nikoh to'yi (FHDK)",                   estimatedCost: 200000,   sortOrder: 3 },
];

// Initial plan template
export const defaultPlan = {
  id: 1,
  title: "Mening to'yim",
  weddingDate: null,
  regionId: null,
  districtId: null,
  totalBudget: 0,
  notes: '',
  status: 'planning',
};

export const formatMoney = (amount) => {
  if (!amount && amount !== 0) return '—';
  return Number(amount).toLocaleString('uz-UZ').replace(/,/g, ' ') + ' so\'m';
};

export const paymentStatuses = [
  { value: 'unpaid',  label: "To'lanmagan",    color: '#ff4d4f' },
  { value: 'partial', label: "Qisman to'langan", color: '#faad14' },
  { value: 'paid',    label: "To'liq to'langan",  color: '#52c41a' },
];
